import { LoadingHeading, LoadingParagraph } from '@zg-rentals/loading-components';

import { Box } from '@zillow/constellation-10';

const CreditTrackingLoader = () => {
  return (
    <Box
      css={{
        minHeight: '50px',
        marginBottom: 'token(spacing.md) !important',
      }}
    >
      <div>
        <Box css={{ marginBottom: 'token(spacing.lg)' }}>
          <LoadingHeading isLoading={true} loadingWidth="200px" level={2} textStyle="heading-sm">
            Loading...
          </LoadingHeading>
          <LoadingParagraph isLoading={true} loadingWidth="80%" css={{ marginTop: 'token(spacing.sm)' }}>
            Loading...
          </LoadingParagraph>
        </Box>
      </div>
    </Box>
  );
};

export default CreditTrackingLoader;
